import {
  validateDisclaimer,
  validateCohortVisibility,
  validateEmail,
  validateFile,
  validatelCountrySate,
  validatelMobileNo,
  validateName,
  validateSelectField,
  validateNameinCohort,
  validatelCountry,
  validateDuration,
  validateDurationText,
  validateNumber,
  validateNumber2,
  validateSelectFieldlabel,
  validateBanner,
  validateNumber12,
  validateDate,
  validateName00,
  validateNumber00,
  validateFile00,
  validateNumber01,
  validateMentorID,
  validateNumber15,
  validateNumber002,
  validateDate2,
} from "../common/dependencies/utils/validation";

export default {
  validateStep1: (params) => {
    const { mentor_name, organization_name, organization_type } = params;
    let formStatus = {};
    const fullnameStatus = validateName(
      mentor_name,
      "Please Enter Your Full Name"
    );
    // const genderStatus = validatelCountry(
    //   gender,
    //   "*Please Select Gender"
    // );
    const OrganizationStatus = validateName(
      organization_name,
      "Please Enter Organization Name"
    );
    const organizationtypeStatus = validateSelectFieldlabel(
      organization_type,
      "*Please Enter Organization Type"
    );

    formStatus = {
      mentorname: fullnameStatus.error,
      // gender: genderStatus.error,
      organizationname: OrganizationStatus.error,
      organization_type: organizationtypeStatus.error,

      hasErrors:
        fullnameStatus.hasError ||
        //  genderStatus.hasError ||
        OrganizationStatus.hasError ||
        organizationtypeStatus.hasError,
    };
    return formStatus;
  },

  validateStep2: (params) => {
    //
    const {
      program_name,
      program_desc,
      uploadBanner,
      program_duration,
      program_duration_text,
      cohort_date,
      startup_start_date,
      startup_end_date,
      infiniteDuration,
    } = params;
    let formStatus = {};
    const programnameStatus = validateNameinCohort(
      program_name,
      "Please Enter Program Name"
    );
    const programdescStatus = validateName00(
      program_desc,
      "Please Enter Program Description"
    );
    const bannerpictureStatus = validateBanner(
      uploadBanner,
      "*Please Upload Banner"
    );
    const program_durationStatus = validateNumber12(
      program_duration,
      infiniteDuration,
      "Program Duration Should Be Minimum 3 Months"
    );
    const cohortdateStatus = validateDate(
      cohort_date,
      "Please Enter Start Date",
    );
    const startup_startdateStatus = validateDate(
      startup_start_date,
      "Please Enter Start Date",
    );
    const startup_enddateStatus = validateDate2(
      startup_end_date,
      "Please Enter End Date",
      infiniteDuration
    );
    const program_duration_textStatus = validateDurationText(
      program_duration_text,
      "Program Duration Should Be Minimum Three Months In Text"
    );

    // const countryStatus = validatelCountrySate(
    //   country,
    //   "Please Select Country"
    // );
    // const StateStatus = validatelCountrySate(state, "Please Select State");
    // const cityStatus = validateName(city, "Please Enter City ");

    formStatus = {
      programname: programnameStatus.error,
      programdesc: programdescStatus.error,
      uploadBanner: bannerpictureStatus.error,
      program_duration: program_durationStatus.error,
      cohort_date: cohortdateStatus.error,
      startup_start_date: startup_startdateStatus.error,
      startup_end_date: startup_enddateStatus.error,
      program_duration_text: program_duration_textStatus.error,
      //   country: countryStatus.error,
      //   state: StateStatus.error,
      //   city: cityStatus.error,
      hasErrors:
        programnameStatus.hasError ||
        programdescStatus.hasError ||
        bannerpictureStatus.hasError ||
        program_durationStatus.hasError ||
        cohortdateStatus.hasError ||
        startup_startdateStatus.hasError ||
        startup_enddateStatus.hasError ||
        program_duration_textStatus.hasError,
      //   ||
      //     countryStatus.hasError ||
      //     StateStatus.hasError ||
      //     cityStatus.hasError,
    };
    //
    return formStatus;
  },

  validateStep2newcohort: (params) => {
    //
    const {
      program_name,
      program_desc,
      uploadBanner,
      program_duration,
      program_duration_text,
      infiniteDuration,
      // cohort_date,
      // startup_start_date,
      // startup_end_date,
    } = params;
    let formStatus = {};
    const programnameStatus = validateNameinCohort(
      program_name,
      "Please Enter Program Name"
    );
    const programdescStatus = validateName00(
      program_desc,
      "Please Enter Program Description"
    );
    const bannerpictureStatus = validateBanner(
      uploadBanner,
      "*Please Upload Banner"
    );
    const program_durationStatus = validateNumber12(
      program_duration,
      infiniteDuration,
      "Program Duration Should Be Minimum 3 Months"
    );
    // const cohortdateStatus = validateDate(
    //   cohort_date,
    //   "Please Enter Start Date"
    // );
    // const startup_startdateStatus = validateDate(
    //   startup_start_date,
    //   "Please Enter Start Date"
    // );
    // const startup_enddateStatus = validateDate(
    //   startup_end_date,
    //   "Please Enter End Date"
    // );
    const program_duration_textStatus = validateDurationText(
      program_duration_text,
      "Program Duration Should Be Minimum Three Months In Text"
    );

    // const countryStatus = validatelCountrySate(
    //   country,
    //   "Please Select Country"
    // );
    // const StateStatus = validatelCountrySate(state, "Please Select State");
    // const cityStatus = validateName(city, "Please Enter City ");

    formStatus = {
      programname: programnameStatus.error,
      programdesc: programdescStatus.error,
      uploadBanner: bannerpictureStatus.error,
      program_duration: program_durationStatus.error,
      // cohort_date: cohortdateStatus.error,
      // startup_start_date: startup_startdateStatus.error,
      // startup_end_date: startup_enddateStatus.error,
      program_duration_text: program_duration_textStatus.error,
      //   country: countryStatus.error,
      //   state: StateStatus.error,
      //   city: cityStatus.error,
      hasErrors:
        programnameStatus.hasError ||
        programdescStatus.hasError ||
        bannerpictureStatus.hasError ||
        program_durationStatus.hasError ||
        // cohortdateStatus.hasError ||
        // startup_startdateStatus.hasError ||
        // startup_enddateStatus.hasError ||
        program_duration_textStatus.hasError,
      //   ||
      //     countryStatus.hasError ||
      //     StateStatus.hasError ||
      //     cityStatus.hasError,
    };
    //
    return formStatus;
  },

  validateStep3: (params) => {
    const {
      hoursperweek,
      numberofmentors,
      // uploadAttach,
      enrolementIds2,
      mentorEnrolmentIdList,
      defaultMentorID,
    } = params;
    let formStatus = {};
    const hoursperweekStatus = validateNumber(
      hoursperweek,
      "Please Enter Hours Per Week"
    );
    const numberofmentorsStatus = validateNumber002(
      numberofmentors,
      "Please Enter Number of Mentors"
    );
    const enrolmentidnewStatus = validateSelectField(
      enrolementIds2,
      "*Please Select Enrolment Id's of Mentors"
    );
    // const uploadAttachStatus = validateFile00(
    //   uploadAttach,
    //   "*Please Select File"
    // );

    // const mentorenrolmentidStatus = validateNumber2(
    //   mentorenrolmentid,
    //   "Please Enter Enrolment Ids of Mentors"
    // );

    // const mentorenrolmentidStatus = validateMentorID(
    //   mentorEnrolmentIdList,
    //   numberofmentors,
    //   defaultMentorID,
    //   "Please Enter Enrolment Ids of Mentors"
    // );
    //
    formStatus = {
      hoursperweek: hoursperweekStatus.error,
      numberofmentors: numberofmentorsStatus.error,
      enrolementIds2: enrolmentidnewStatus.error,
      // uploadAttach: uploadAttachStatus.error,

      // mentorenrolmentid: mentorenrolmentidStatus.error,
      hasErrors:
        hoursperweekStatus.hasError ||
        numberofmentorsStatus.hasError ||
        enrolmentidnewStatus.hasError 
        // ||
        // uploadAttachStatus.hasError,
      // mentorenrolmentidStatus.hasError,
    };
    return formStatus;
  },

  validateStep4: (params) => {
    const {
      numberofstartups,
      industry,
      specialization,
      preferredStage,
      disclaimer,
      cohortVisibility
    } = params;
    let formStatus = {};
    // const numberofstartupsStatus = validateNumber01(
    const numberofstartupsStatus = validateNumber15(
      numberofstartups,
      "Please Enter Number of Startups"
    );
    const industryStatus = validateSelectField(
      industry,
      "*Please Select industry"
    );
    // const subindustryStatus = validateSelectField(
    //   subindustry,
    //   "*Please Select Industry/Sector Keywords"
    // );
    const specializationStatus = validateSelectField(
      specialization,
      "*Please Select Specialization"
    );
    // const subspecializationStatus = validateSelectField(
    //   subspecialization,
    //   "*Please Select Specialization/Function Keywords"
    // );
    const preferredStageStatus = validateSelectField(
      preferredStage,
      "*Please Select preferredStage"
    );
    const disclaimerStatus = validateDisclaimer(disclaimer);
    const cohortVisibilityStatus = validateCohortVisibility(cohortVisibility);
    formStatus = {
      numberofstartups: numberofstartupsStatus.error,
      industry: industryStatus.error,
      // subindustry: subindustryStatus.error,
      // specialization: specializationStatus.error,
      // subspecialization: subspecializationStatus.error,
      preferredStage: preferredStageStatus.error,
      disclaimer: disclaimerStatus.error,
      cohortVisibility:cohortVisibilityStatus.error,
      hasErrors:
        numberofstartupsStatus.hasError ||
        // industryStatus.hasError ||
        // subindustryStatus.hasError ||
        // specializationStatus.hasError ||
        // subspecialization.hasError ||
        // preferredStageStatus.hasError ||
        disclaimerStatus.hasError,
    };
    return formStatus;
  },

  //   validateStep5: (params) => {
  //     //
  //     const { uploadResume, disclaimer } = params;
  //     let formStatus = {};
  //     const uploadResumeStatus = validateFile(uploadResume);
  //     const disclaimerStatus = validateDisclaimer(disclaimer);

  //     formStatus = {
  //       uploadResume: uploadResumeStatus.error,
  //       disclaimer: disclaimerStatus.error,
  //       hasErrors: uploadResumeStatus.hasError || disclaimerStatus.hasError,
  //     };
  //     return formStatus;
  //   },
};
